import React, { useCallback, useState }   from 'react';
import { useDropzone }          from 'react-dropzone';
import { useTranslation }       from 'react-i18next';
import CircularProgress         from '@material-ui/core/CircularProgress';
import xlsxToJson               from '~/utils/xlsxToJson';

function InputDropzoneFile(props) {
  const [loading, setLoading] = useState(false);
  const { onChange, sendAlready } = props;

  const onDrop = useCallback(acceptedFiles => {
    setLoading(true);
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      xlsxToJson(reader.result).then((value) => {
        onChange(value);
        setLoading(false);
      });
    };

    acceptedFiles.forEach(file => {
      reader.readAsBinaryString(file);
    });
  }, []);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
  });

  const { t } = useTranslation();

  return (
    <section style={{ paddingTop: 30 }} className="container">
      <div disabled={sendAlready} hidden={sendAlready} style={{ borderRadius: 5, backgroundColor: '#efefef', padding: 10, borderWidth: 1, borderColor: '#e3e3e3' }} {...getRootProps({className: 'dropzone'})}>
        <input disabled={sendAlready} hidden={sendAlready} {...getInputProps()} />
        {!loading && <p style={{textAlign: 'center'}}>{t('dropzone_file_placeholder')}</p>}
        {loading && <CircularProgress color={'primary'}/>}
      </div>
    </section>
  );
}

export default InputDropzoneFile;
